import { IPlatformEvent } from 'modules/event-manager/event-manager.service';

export function getEarliestPlatform(platforms: IPlatformEvent[]): IPlatformEvent {
    let platformWithEarliestStartDate = platforms[0];

    for (let i = 1; i < platforms.length; i++) {
        const platform = platforms[i];
        if (platformWithEarliestStartDate.startDate > platform.startDate) {
            platformWithEarliestStartDate = platform;
        }
    }

    return platformWithEarliestStartDate;
}
